import { jsxs as e, Fragment as l, jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ e(l, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M5.25 15C5.25 15.9665 6.0335 16.75 7 16.75H9C9.9665 16.75 10.75 15.9665 10.75 15V12C10.75 11.0335 9.9665 10.25 9 10.25H7C6.0335 10.25 5.25 11.0335 5.25 12L5.25 15ZM7 15.25C6.86193 15.25 6.75 15.1381 6.75 15V12C6.75 11.8619 6.86193 11.75 7 11.75H9C9.13807 11.75 9.25 11.8619 9.25 12V15C9.25 15.1381 9.13807 15.25 9 15.25H7Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M2 19.2632C2 20.7747 3.26279 22 4.82051 22H19.1795C20.7372 22 22 20.7747 22 19.2632L22 10.4219C22 9.55061 21.5512 8.73695 20.8041 8.25363L13.5645 2.45965C12.6171 1.84678 11.3829 1.84678 10.4355 2.45965L3.19592 8.25363C2.44878 8.73695 2 9.55061 2 10.4219V19.2632ZM19.6331 9.87813L12.4169 4.10285C12.1597 3.96572 11.8403 3.96572 11.5831 4.10285L4.36689 9.87813L4.28222 9.9329C4.0901 10.0572 4 10.2464 4 10.4219V19.2632C4 19.6138 4.31014 20 4.82051 20H12.25V15.5C12.25 13.7051 13.7051 12.25 15.5 12.25C17.2949 12.25 18.75 13.7051 18.75 15.5V20H19.1795C19.6899 20 20 19.6138 20 19.2632L20 10.4219C20 10.2464 19.9099 10.0572 19.7178 9.9329L19.6331 9.87813ZM15.5 13.75C14.5335 13.75 13.75 14.5335 13.75 15.5V20H17.25V15.5C17.25 14.5335 16.4665 13.75 15.5 13.75Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  )
] });
export {
  o as default
};
